import { gql } from '@apollo/client';

export const GET_VOLUNTEER_DATE_CREATED = gql`
  query GetVolunteerDateCreated($volunteerId: String!) {
    vm {
      volunteer(volunteerId: $volunteerId) {
        volunteerId
        dateCreated
        currentOnboardingStep {
          volunteerOnboardingStepType {
            order
          }
        }
      }
    }
  }
`;
